
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
import { getUuid } from "@common/src/utils/common";
import { VueCropper } from "vue-cropper";
const base = namespace("base");
@Component({
  components: {
    VueCropper
  }
})
export default class ImgCropper extends Vue {
  @base.Action getUploadToken;
  @Prop({ default: false })
  //   cropperVisible = true;
  cropperVisible: boolean;
  @Prop({ default: () => {} })
  cutImage: any;
  @Prop({ default: () => {}, type: Object })
  option: any;
  loading: boolean = false;
  t = t;
  uploadUrl: string = "";
  uploadTokenObj: any = {};
  fileList: any = [];
  //   cutImage: any = {
  //     url: "",
  //     index: ""
  //   };
  get assignOption() {
    return Object.assign(this.defaultOption, this.option);
  }
  defaultOption = {
    img: "", // 裁剪图片的地址
    info: true, // 裁剪框的大小信息
    outputSize: 1, // 裁剪生成图片的质量
    outputType: "jpg", // 裁剪生成图片的格式
    canScale: true, // 图片是否允许滚轮缩放
    autoCrop: true, // 是否默认生成截图框
    autoCropWidth: 1050, // 默认生成截图框宽度
    autoCropHeight: 252, // 默认生成截图框高度
    fixedBox: true, // 固定截图框大小 不允许改变
    // canMove: true, // 截图框限制移动
    // fixed: true, // 是否开启截图框宽高固定比例
    // fixedNumber: [1, 1], // 截图框的宽高比例
    full: true, // 是否输出原图比例的截图
    canMoveBox: false, // 截图框能否拖动
    original: true, // 上传图片按照原始比例渲染
    centerBox: true, // 截图框是否被限制在图片里面
    // infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
    enlarge: 1 // 图片根据截图框输出比例倍数
  };
  //计算属性
  get breadData() {
    return [];
  }

  handleInsert() {
    console.log(1123);
    this.loading = true;
    (this.$refs.cropper as any).getCropBlob(async blob => {
      await this.uploadFileCb();
      await this.uploadImage(this.blobChangeFile(blob));
    });
  }
  // Blob转File
  blobChangeFile(blob) {
    let file = new File([blob], t("v210831.picture-clipping-jpg"), { type: "image/webp" });
    return file;
  }
  uploadImage(file) {
    var xhr, formData;
    xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open("POST", this.uploadUrl);
    formData = new FormData();
    Object.keys(this.uploadTokenObj).forEach(key => {
      formData.append(key, this.uploadTokenObj[key]);
    });
    formData.append("file", file);
    xhr.send(formData);
    xhr.onload = () => {
      if (xhr.status === 200) {
        this.emitChange({
          name: file.name,
          url: this.uploadTokenObj.domain + "/" + this.uploadTokenObj.key
        });
        this.handleClose();
        this.loading = false;
      } else {
        console.log('[ "HTTP Error: " + xhr.status ]', "HTTP Error: " + xhr.status);
      }
    };
  }
  emitChange(fileObj) {
    this.$emit("getCropperImg", fileObj);
  }
  uploadFileCb() {
    return this.getUploadToken({
      businessType: "0",
      businessCode: "000000000"
    }).then(data => {
      this.uploadTokenObj = {
        url: data.data.host,
        key: `${data.data.dir}/${getUuid(15)}`, // 名字里如果有,会被切割
        // key: `${data.data.dir}/${getUuid(15)}/${file.name}`,
        policy: data.data.policy,
        OSSAccessKeyId: data.data.accessId,
        Signature: data.data.signature,
        success_action_status: 200,
        domain: data.data.domain
      };
      this.uploadUrl = data.data.host;
    });
  }
  handleClose() {
    this.$emit("close", false);
  }
  beforeClose() {
    this.$emit("close", false);
  }
  //   ///
}
